<div class="message-dock">
  @if (notify.preview(); as item) {
    <app-custom-snackbar [data]="item" [unreadCount]="notify.unreadCount()"
      (dismiss)="notify.dismissPreview()" (review)="open()"
      (mouseenter)="notify.pausePreview('hover', true)" (mouseleave)="notify.pausePreview('hover', false)"
      (focusin)="notify.pausePreview('focus', true)" (focusout)="focusLeft($event)" />
  }
  <button class="launcher" [class.needs-attention]="notify.attentionCount() > 0" (click)="open()"
    aria-haspopup="dialog" [attr.aria-label]="'Messages système, ' + notify.unreadCount() + ' à lire'">
    <app-message-icon [name]="notify.attentionCount() ? 'error_outline' : 'forum'" />
    Messages système
    @if (notify.unreadCount()) { <span class="count">{{ notify.unreadCount() }}</span> }
  </button>
</div>
<span class="sr-only" role="status" aria-live="polite" aria-atomic="true">
  @if (notify.unreadCount()) { {{ notify.unreadCount() }} messages système à lire, dont {{ notify.attentionCount() }} erreurs ou avertissements. }
</span>

<ng-template #panel>
  <section class="message-panel">
    <header class="panel-header">
      <div>
        <span class="eyebrow">VOTRE ACTIVITÉ</span>
        <h2 id="system-messages-title">Messages système</h2>
      </div>
      <button class="icon-button panel-close" mat-dialog-close aria-label="Fermer les messages système">
        <app-message-icon name="close" />
      </button>
    </header>
    <p class="intro">Prenez le temps de les lire. Fermer un aperçu ou ce panneau conserve les messages non lus.</p>
    <div class="filters" aria-label="Filtrer les messages">
      <button [class.selected]="filter() === 'unread'" [attr.aria-pressed]="filter() === 'unread'" (click)="filter.set('unread')">À lire <span>{{ notify.unreadCount() }}</span></button>
      <button [class.selected]="filter() === 'all'" [attr.aria-pressed]="filter() === 'all'" (click)="filter.set('all')">Historique <span>{{ notify.notifications().length }}</span></button>
    </div>
    <div class="panel-actions">
      <button [disabled]="!notify.unreadCount()" (click)="notify.markAllRead()">Tout marquer comme lu</button>
      <button [disabled]="!hasRead()" (click)="notify.clearRead()">Effacer les lus</button>
    </div>
    <div class="message-list" tabindex="0" aria-label="Liste des messages système">
      @for (item of visibleItems(); track item.id) {
        <article [class]="'message-card ' + item.type" [class.is-read]="item.read" [attr.aria-label]="labels[item.type] + ' : ' + item.message">
          <div class="card-top">
            <span class="severity"><app-message-icon [name]="icons[item.type]" />{{ labels[item.type] }}</span>
            <time [attr.datetime]="item.lastOccurredAt | date:'yyyy-MM-ddTHH:mm:ss'">{{ item.lastOccurredAt | date:'dd/MM HH:mm:ss' }}</time>
          </div>
          <h3>{{ item.title || labels[item.type] }}</h3>
          <p class="context">{{ item.source }}@if (item.operation) { · {{ item.operation }} }</p>
          <p class="message-text">{{ item.message }}</p>
          @if (item.errors?.length) {
            <ul class="validation-errors">@for (error of item.errors; track $index) { <li>{{ error }}</li> }</ul>
          }
          @if (item.occurrences > 1) { <p class="repeat">Répété {{ item.occurrences }} fois · première fois à {{ item.createdAt | date:'HH:mm:ss' }}</p> }
          @if (item.endpoint || item.status !== undefined) {
            <details>
              <summary>Détails de la requête</summary>
              <dl>
                <dt>Service</dt><dd>{{ item.source }}</dd>
                <dt>Résultat</dt><dd>{{ item.status === 0 ? 'Serveur injoignable' : 'HTTP ' + item.status }}</dd>
                @if (item.endpoint) { <dt>Requête</dt><dd><code>{{ item.method }} {{ item.endpoint }}</code></dd> }
              </dl>
            </details>
          }
          <div class="card-footer">
            @if (item.read) { <span class="read-label"><app-message-icon name="done" /> Lu</span> }
            @else { <button (click)="notify.markRead(item.id)"><app-message-icon name="done" /> Marquer comme lu</button> }
          </div>
        </article>
      } @empty {
        <div class="empty-state">
          <app-message-icon [name]="filter() === 'unread' ? 'task_alt' : 'forum'" />
          <h3>{{ filter() === 'unread' ? 'Vous avez tout lu' : 'Aucun message pour le moment' }}</h3>
          <p>{{ filter() === 'unread' ? 'Les messages déjà lus restent dans l’historique.' : 'Les résultats de vos actions apparaîtront ici.' }}</p>
        </div>
      }
    </div>
    <footer class="panel-footer">Historique de cette session, conservé pendant la navigation.<br>Réinitialisé au rechargement ou au changement de compte.</footer>
  </section>
</ng-template>
